// 20.2.2.14 Math.expm1(x)
var $export = require('./$.export');

$export($export.S, 'Math', {expm1: require('./$.math-expm1')});


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/es6.math.expm1.js
// module id = 228
// module chunks = 0